import Index from './index.vue'
// import Create from './components/Create.vue'
import List from './components/List.vue'
// import Edit from './components/Edit.vue'

export default [
  {
    path: 'events',
    name: 'events',
    component: Index,
    title: 'events',
    redirect: { name: 'events-list' },
    children: [
      
      {
        path: 'list',
        name: 'events-list',
        component: List,
      },
      
    ],
  },
]
